import { useTranslation } from 'react-i18next';
import apiDefinitions from '../loyalty-performance-api-defintitions';
import APIDefinitions from 'components/api-definitions/api-definitions.component';

const locationDefinitions = [apiDefinitions.locationName];

const LocationDefinitions = () => {
  const { t } = useTranslation();

  return (
    <APIDefinitions
      definitions={locationDefinitions}
      type={t(
        'page.loyaltyPerformanceReport.apiDefinitionTitles.location.label',
      )}
    />
  );
};

export default LocationDefinitions;
